<template>
  <div class="yu-menu">
    <ul>
      <li class="yu-menu-item title">安装指南</li>
      <router-link to="/install" tag="li" class="yu-menu-item">安装</router-link>
      <router-link to="/theme" tag="li" class="yu-menu-item">自定义主题</router-link>
      <router-link to="/icon" tag="li" class="yu-menu-item">原创icon图标</router-link>
      <li class="yu-menu-item">
        <a href="https://github.com/yurencloud/yu.mobile" target="_blank">
        <i class="iconfont icon-github-circle"></i>Github
        </a>
      </li>
      <li class="yu-menu-item title">组件</li>
      <router-link to="/popover" tag="li" class="yu-menu-item">popover 气泡菜单</router-link>
      <router-link to="/button" tag="li" class="yu-menu-item">button 按钮</router-link>
      <router-link to="/tabs" tag="li" class="yu-menu-item">tabs 标签页</router-link>
      <router-link to="/tab-bar" tag="li" class="yu-menu-item">tab-bar 标签栏</router-link>
      <router-link to="/checkbox" tag="li" class="yu-menu-item">checkbox 复选框</router-link>
      <router-link to="/radio" tag="li" class="yu-menu-item">radio 单选框</router-link>
      <router-link to="/input" tag="li" class="yu-menu-item">input 输入框</router-link>
      <router-link to="/picker" tag="li" class="yu-menu-item">picker 选择器</router-link>
      <router-link to="/switch" tag="li" class="yu-menu-item">switch 开关</router-link>
      <router-link to="/search" tag="li" class="yu-menu-item">search 搜索框</router-link>
      <router-link to="/notice" tag="li" class="yu-menu-item">notice 通告栏</router-link>
      <router-link to="/loading" tag="li" class="yu-menu-item">loading 加载器</router-link>
      <router-link to="/action" tag="li" class="yu-menu-item">action 动作菜单</router-link>
      <router-link to="/modal" tag="li" class="yu-menu-item">modal 对话框</router-link>
      <router-link to="/toast" tag="li" class="yu-menu-item">toast 提示框</router-link>
      <router-link to="/result" tag="li" class="yu-menu-item">result 结果页</router-link>
      <router-link to="/refresh" tag="li" class="yu-menu-item">refresh 下拉刷新</router-link>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'YuHead',
};
</script>

<style lang="scss" scoped type="text/scss">
  @import "../assets/css/varible";

  .yu-menu {
    vertical-align: top;
    display: inline-block;
    box-sizing: border-box;
    width: 22%;
    min-height: 600px;
    background: #fff;
    border: 1px solid $border;
    margin-right: 20px;
    font-size: $big;
    ul {
      padding: 0;
      margin: 0;
    }
    ul li {
      box-sizing: border-box;
      width: 100%;
      height: 40px;
      line-height: 40px;
      padding: 0 20px;
      color: $text;
      transition: background-color .4s;
      text-align: left;
      list-style: none;
      &:hover:not(.title) {
        background: $background;
      }
      &.title {
        color: $text;
        font-weight: bold;
        padding: 0 20px;
      }
    }
    .router-link-active{
      background: $background;
      color: $primary;
      font-weight: bold;
      border-right: 3px solid $primary;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/yu-menu.vue